var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAi = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 19.4,
    height: 19.4,
    rx: 1.7,
    stroke: "#C2CDD6",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.132 15L9.196 12.348H6.016L5.092 15H4L7.12 6.396H8.128L11.236 15H10.132ZM7.996 8.796C7.98 8.732 7.944 8.616 7.888 8.448C7.84 8.28 7.788 8.108 7.732 7.932C7.684 7.748 7.644 7.608 7.612 7.512C7.572 7.672 7.528 7.836 7.48 8.004C7.44 8.164 7.4 8.312 7.36 8.448C7.32 8.584 7.284 8.7 7.252 8.796L6.364 11.388H8.884L7.996 8.796ZM14.6502 15H11.6862V14.376L12.6342 14.148V7.296L11.6862 7.056V6.432H14.6502V7.056L13.7022 7.296V14.148L14.6502 14.376V15Z",
    fill: "#778592"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IconAI.d38d2d20cc3d42ba72e855a233e8073b.svg";